import DaoBase from "./base";

class DaoCategory extends DaoBase {
    class;
    code;
    color;
    image;
    order;
    parid;
    proid;
    proname;

    selected = false;
    /** @type {DaoCategory[]} */
    lists;

    constructor(json=null) {
        super(json);
    }
}

export default DaoCategory;


// WEBPACK FOOTER //
// ./src/modules/dao/category.js